import React, { Component } from 'react';

const ROLE_OPTIONS = [
    { value: 'admin', label: 'Admin', color: '#dc3545' },
    { value: 'user', label: 'User', color: '#6c757d' }
];

export class UserMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loading: true,
            search: '',
            editItem: null,
            form: { id: 0, username: '', displayName: '', role: 'user', isActive: 1, password: '' }
        };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/users')
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    openAdd() {
        this.setState({ editItem: { id: 0 }, form: { id: 0, username: '', displayName: '', role: 'user', isActive: 1, password: '' } });
    }
    openEdit(u) {
        this.setState({ editItem: u, form: { id: u.id, username: u.username, displayName: u.displayName || '', role: u.role || 'user', isActive: u.isActive, password: '' } });
    }
    closeModal() { this.setState({ editItem: null }); }

    upd(field, val) { this.setState({ form: { ...this.state.form, [field]: val } }); }

    async save() {
        var { form } = this.state;
        if (form.id === 0) {
            if (!form.username.trim()) { alert('กรุณากรอก username'); return; }
            if (!form.password) { alert('กรุณากรอก password'); return; }
        }
        try {
            var r = await fetch('api/users', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form)
            });
            if (!r.ok) {
                var e = await r.json().catch(() => ({}));
                throw new Error(e.message || 'save failed');
            }
            this.closeModal();
            this.load();
        } catch (e) { alert('บันทึกไม่สำเร็จ: ' + e.message); }
    }

    async del(u) {
        if (u.username === 'admin') { alert('ไม่สามารถลบบัญชี admin หลักได้'); return; }
        if (!window.confirm('ต้องการลบผู้ใช้ "' + u.username + '" หรือไม่?')) return;
        try {
            var r = await fetch('api/users/' + u.id, { method: 'DELETE' });
            if (!r.ok) throw new Error('delete failed');
            this.load();
        } catch (e) { alert('ลบไม่สำเร็จ: ' + e.message); }
    }

    getFiltered() {
        var { list, search } = this.state;
        if (!search.trim()) return list;
        var s = search.trim().toLowerCase();
        return list.filter(u =>
            (u.username || '').toLowerCase().includes(s) ||
            (u.displayName || '').toLowerCase().includes(s) ||
            (u.role || '').toLowerCase().includes(s)
        );
    }

    render() {
        var { loading, search, editItem, form } = this.state;
        var filtered = this.getFiltered();
        var roleMeta = (r) => ROLE_OPTIONS.find(x => x.value === r) || { label: r, color: '#888' };

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {filtered.length} รายการ</p>
                    <button className="btn btn-danger" onClick={() => this.openAdd()}><i className="fas fa-plus"></i> เพิ่ม User</button>
                </div>

                <div style={{ background: '#fff', borderRadius: 10, padding: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 }}>
                    <div className="input-group" style={{ maxWidth: 400 }}>
                        <span className="input-group-text" style={{ background: '#fff' }}><i className="fas fa-search" style={{ color: '#aaa' }}></i></span>
                        <input className="form-control" placeholder="ค้นหา username, ชื่อ, role..." value={search} onChange={e => this.setState({ search: e.target.value })} style={{ borderLeft: 'none' }} />
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-inbox" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        {search ? 'ไม่พบรายการ' : 'ยังไม่มี User'}
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                        <table className="table table-hover" style={{ margin: 0 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 60 }}>#</th>
                                    <th>Username</th>
                                    <th>ชื่อที่แสดง</th>
                                    <th style={{ width: 120 }}>Role</th>
                                    <th style={{ width: 100 }}>สถานะ</th>
                                    <th style={{ width: 140, textAlign: 'right' }}>จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map(u => {
                                    var rm = roleMeta(u.role);
                                    return (
                                        <tr key={u.id}>
                                            <td>{u.id}</td>
                                            <td style={{ fontWeight: 600 }}><i className="fas fa-user-circle" style={{ color: '#aaa', marginRight: 6 }}></i>{u.username}</td>
                                            <td>{u.displayName || '-'}</td>
                                            <td><span style={{ background: rm.color, color: '#fff', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700 }}>{rm.label}</span></td>
                                            <td>
                                                {u.isActive ? <span style={{ color: '#28a745', fontWeight: 600, fontSize: 12 }}><i className="fas fa-check-circle"></i> Active</span>
                                                    : <span style={{ color: '#6c757d', fontSize: 12 }}><i className="fas fa-pause-circle"></i> Inactive</span>}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                <div className="d-inline-flex" style={{ gap: 8 }}>
                                                    <button className="btn btn-sm btn-outline-primary" onClick={() => this.openEdit(u)}><i className="fas fa-edit"></i></button>
                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => this.del(u)}><i className="fas fa-trash"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {editItem && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => this.closeModal()}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '90%', maxWidth: 500 }} onClick={e => e.stopPropagation()}>
                            <h5 style={{ marginBottom: 16 }}>{editItem.id ? 'แก้ไข' : 'เพิ่ม'}ผู้ใช้งาน</h5>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 600 }}>Username *</label>
                                <input className="form-control" value={form.username} disabled={editItem.id > 0}
                                    onChange={e => this.upd('username', e.target.value)} autoFocus placeholder="เช่น somsak" />
                                {editItem.id > 0 && <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>Username ไม่สามารถแก้ไขได้</div>}
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 600 }}>ชื่อที่แสดง</label>
                                <input className="form-control" value={form.displayName} onChange={e => this.upd('displayName', e.target.value)} placeholder="เช่น สมศักดิ์ ทดสอบ" />
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 600 }}>Role</label>
                                <select className="form-control" value={form.role} onChange={e => this.upd('role', e.target.value)}>
                                    {ROLE_OPTIONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                                </select>
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize: 13, fontWeight: 600 }}>Password {editItem.id === 0 ? '*' : '(ใส่เฉพาะเมื่อต้องการเปลี่ยน)'}</label>
                                <input className="form-control" type="password" value={form.password}
                                    onChange={e => this.upd('password', e.target.value)} placeholder={editItem.id === 0 ? 'รหัสผ่านใหม่' : 'ปล่อยว่างถ้าไม่เปลี่ยน'} />
                            </div>

                            {editItem.id > 0 && (
                                <div className="mb-3">
                                    <label style={{ fontSize: 13, fontWeight: 600 }}>สถานะ</label>
                                    <div className="btn-group d-block">
                                        <button type="button" className={'btn btn-sm ' + (form.isActive ? 'btn-success' : 'btn-outline-success')} onClick={() => this.upd('isActive', 1)}><i className="fas fa-check-circle"></i> Active</button>
                                        <button type="button" className={'btn btn-sm ' + (!form.isActive ? 'btn-secondary' : 'btn-outline-secondary')} onClick={() => this.upd('isActive', 0)}><i className="fas fa-pause-circle"></i> Inactive</button>
                                    </div>
                                </div>
                            )}

                            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                                <button className="btn btn-outline-secondary" onClick={() => this.closeModal()}>ยกเลิก</button>
                                <button className="btn btn-danger" onClick={() => this.save()}><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
